import moment from "moment-timezone";

moment.suppressDeprecationWarnings = true;

let userLocale = window.navigator.language;

export default function localDateTimeFormatter(data){
    let tm = moment(data);
    return tm.locale(userLocale).format("L") + " " + tm.locale(userLocale).format("LTS");
}

export function getFileSizeFormatter(fileSize) {
    return formatBytes(fileSize)
}

function formatBytes(bytes,decimals) {
    let k = 1024,
        dm = decimals || 2,
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}